<template>
  <div class="select-stay-period">
    <div
      class="select-stay-period__datepicker"
    >
      <Datepicker
        :language="datepickerOptions.language"
        :disabled-dates="datepickerOptions.disabledDates"
        :format="datepickerOptions.format"
        :placeholder="datepickerOptions.placeholder"
        @input="setCheckInDate"
        v-model="selectedCheckInDate"
      />
      <button
        v-if="selectedCheckInDate !== ''"
        class="select-stay-period__button --reset"
        @click="resetCheckInDate"
      >
        <img
          src="@/assets/icon/icon_circle_close_black.svg"
          alt=""
        >
      </button>
      <div
        v-else
        class="select-stay-period__icon --calendar"
      >
        <img
          src="@/assets/icon/icon_calendar_black.svg"
          alt=""
        >
      </div>
    </div>
    <AppSelectNumber
      :numbers="6"
      :value="Number(selectedStayNights)"
      label="泊"
      class="select-stay-period__select --stay-night"
      @inputed="setStayNights"
      :disabled="selectedCheckInDate === ''"
    />
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker"
import { ja } from 'vuejs-datepicker/dist/locale'
import AppSelectNumber from '@/components/elements/AppSelectNumber/'

export default {
  components: {
    Datepicker,
    AppSelectNumber
  },
  data() {
    return {
      datepickerOptions: {
        language: ja,
        format: "yyyy/MM/dd（D）",
        disabledDates: {
          to: new Date(new Date().setDate(new Date().getDate() - 1))
        },
        placeholder: "日付指定なし"
      }, // datepickerの設定
      selectedCheckInDate: '', // チェックイン日
      selectedStayNights: 0,   // 宿泊日数
    }
  },
  mounted() {
    const checkInDate = this.$route.query?.checkInDate
      ? this.$route.query.checkInDate
      : ''
    const stayNights = this.$route.query?.stayNights
      ? Number(this.$route.query.stayNights)
      : 1

    this.selectedCheckInDate = checkInDate
    this.selectedStayNights = stayNights

    this.emitData()
  },
  methods: {
    formatDate(date) {
      return date ? this.$moment(date).format("YYYY-MM-DD") : ''
    },
    setCheckInDate(date) {
      this.selectedCheckInDate = this.formatDate(date)
      this.emitData()
    },
    resetCheckInDate() {
      this.selectedCheckInDate = ''
      this.selectedStayNights = 1;
      this.emitData()
    },
    setStayNights(stayNights) {
      this.selectedStayNights = Number(stayNights)
      this.emitData()
    },
    emitData() {
      this.$emit('inputed', {
        checkInDate: this.selectedCheckInDate,
        stayNights: this.selectedStayNights
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixins.scss';
@import '@/assets/scss/variables.scss';

.select-stay-period {
  border: 1px solid $cool-gray-3;
  border-radius: .25rem;
  display: flex;
  height: 2.5rem;

  img {
    display: block;
    height: auto;
    width: 100%;
  }
  
  &__datepicker {
    position: relative;
    width: calc(100% - 3.5rem - 1px);

    &::after {
      background-color: $cool-gray-3;
      content: '';
      display: block;
      mix-blend-mode: multiply;
      height: calc(2.5rem - 16px);
      position: absolute;
      right: -1px;
      top: 7px;
      width: 1px;
    }

    ::v-deep {
      input {
        background-color: transparent;
        cursor: pointer;
        font-feature-settings: "palt";
        height: calc(2.5rem - 2px);
        padding: 0 .5rem;
        width: 100%;

        @include hover {
          border-radius: .25rem;
          outline: 2px solid $black;
          outline-offset: -1px;
        }

        &::placeholder {
          color: $cool-gray-4;
          font-size: .875rem;
        }

        &:focus {
          outline-color: $black;
        }
      }

      .vdp-datepicker__calendar {
        border-radius: .25rem;
        left: -1px;
        width: 16rem;

        @include sp {
          top: -1px;
        }

        > div {
          padding-bottom: .5rem;
        }
      }

      .day-header,
      .day {
        height: 30px;
        line-height: 28px;
      }
    }
  }

  &__select {
    &.--stay-night {
      border-radius: .25rem;
      margin-left: 1px;
      text-align: center;
      width: 3.5rem;

      @include focus {
        outline-offset: -1px;
      }
    }
  }

  &__button {
    &.--reset {
      align-items: center;
      background-color: transparent;
      cursor: pointer;
      display: flex;
      height: 100%;
      justify-content: center;
      padding: 0 .625rem 0 .125rem;
      position: absolute;
      right: 0;
      top: 0;
      width: 2rem;
    }
  }

  &__icon {
    &.--calendar {
      height: 1rem;
      pointer-events: none;
      position: absolute;
      right: .75rem;
      top: 10px;
      width: 1rem;
    }
  }
}
</style>